export const workspace = {
  routes: [
    {
      path: "/workspace/library/policy",
      component: () => import("../workspace-library-policy-view"),
    },
    {
      path: "/workspace/library/policy-category",
      component: () => import("../workspace-library-policy-category-view"),
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/policy",
      component: () => import("../management-library-policy-view"),
    },
    {
      path: "/management/policy-category",
      component: () => import("../management-library-policy-category-view"),
    },
  ],
};
